<template>
  <div style="width: 410px;">
    <div
      class="z-30 rounded border-1 bg-white shadow-sm border-gray-700 text-gray-900 px-3"
    >
      <div class="w-full h-10 flex items-center">
        <div class="flex-shrink w-1/2">
          <svg
            viewBox="0 0 161.06 159.5"
            height="18"
            width="18"
            class="text-gray-900 fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M158.27,57.72l-2.5-2.91V27.52A6.75,6.75,0,0,0,149,20.78H113.26L83.71.93a5.4,5.4,0,0,0-6.06,0L48.07,20.78H12.43a6.75,6.75,0,0,0-6.75,6.74V55.88L3.84,57.53A11.53,11.53,0,0,0,0,66.12v83.39a9.88,9.88,0,0,0,9.88,9.88l4.28.11H146.89a14.18,14.18,0,0,0,14.17-14.17V65.24A11.53,11.53,0,0,0,158.27,57.72ZM58.22,19.17,78.43,5.56a4,4,0,0,1,2.24-.68,3.93,3.93,0,0,1,2.23.68l20.22,13.61a1.34,1.34,0,0,1-.75,2.46H59a1.32,1.32,0,0,1-1.28-1A1.29,1.29,0,0,1,58.22,19.17ZM13.23,26H148.37a2.17,2.17,0,0,1,2.16,2.18l-.22,43.46-44.85,31.21a2,2,0,0,1-1.2.38,2.09,2.09,0,0,1-1.22-.39L87.4,91.09c-4.57-3.74-9.11-3.81-13.64-.09L58,103a2.07,2.07,0,0,1-1.19.37,2,2,0,0,1-1.18-.37L11.07,72.08V28.2A2.18,2.18,0,0,1,13.23,26ZM7.55,143a.72.72,0,0,1-1.13-.59V77.83a.72.72,0,0,1,.72-.72.71.71,0,0,1,.41.13l43.52,30a.73.73,0,0,1,.31.59.75.75,0,0,1-.31.6Zm139,10.06H14.48c-4.8,0-5.66-4-3.41-5.87l44.68-36.15,1.91-1.53,16.1-12c4-3.37,10.15-2.88,14.26.36l62,49.31C152.24,149.12,151.38,153.08,146.58,153.08Zm8.06-10.65a.72.72,0,0,1-.73.72.66.66,0,0,1-.4-.13L110,108.39a.72.72,0,0,1-.31-.6.7.7,0,0,1,.31-.59l43.52-30a.68.68,0,0,1,.4-.13.73.73,0,0,1,.73.72Z"
            />
            <rect x="108.65" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="123.53" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="93.78" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="78.9" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="64.03" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="49.17" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="34.29" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="19.42" y="34.19" width="8.5" height="8.5" rx="1.27" />
            <rect x="19.42" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="34.29" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="49.16" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="64.03" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="78.9" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="93.77" y="61.35" width="5" height="5" rx="0.72" />
            <rect x="34.29" y="74.85" width="5" height="5" rx="0.72" />
            <rect x="49.16" y="74.85" width="5" height="5" rx="0.72" />
            <rect x="64.03" y="74.85" width="5" height="5" rx="0.72" />
            <rect x="78.3" y="74.85" width="5" height="5" rx="0.72" />
          </svg>
        </div>
        <h3 class="font-semibold flex-1 whitespace-no-wrap">
          1 Nytt meddelande
        </h3>
        <div class="flex-shrink w-1/2 flex items-center justify-end">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5 fill-current transition-colors duration-300 text-gray-700"
            viewBox="0 0 24 24"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="flex flex-col overflow-y-auto" style="max-height: 80vh">
        <div class="flex flex-col text-sm" style="width: 24rem">
          <hr />
          <div class="flex justify-between items-start py-2 leading-snug">
            <h3 class="font-semibold" v-if="title">
              {{ title[0].toUpperCase() + title.slice(1) }}
            </h3>
            <h3 v-else class="text-gray-500 italic">Rubrik</h3>
            <span class="text-xs">
              {{ require('moment')().format('HH:mm') }}
            </span>
          </div>
          <div
            style="max-height: 30rem"
            class="w-full flex flex-col overflow-y-auto"
          >
            <p
              v-if="shortMessage"
              class="whitespace-pre-line"
              v-html="shortMessage"
            ></p>
            <p
              v-else-if="longMessage"
              class="whitespace-pre-line line-clamp-3"
              v-html="longMessage"
            ></p>
            <p v-else class="text-gray-500 italic">
              Här visas 'Kort meddelande' om något finns, <br />
              annars visas en bit av 'Långt meddelande'<br />
              <br />
              Finns enbart 'Kort meddelande' går meddelandet <br />
              att markera som läst redan härifrån
            </p>
            <button class="mx-auto mt-4 text-coral-500 font-semibold p-2">
              {{ longMessage ? 'Läs hela meddelandet' : 'Markera som läst' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preview',
  props: {
    title: {
      type: String,
    },
    shortMessage: {
      type: String,
    },
    longMessage: {
      type: String,
    },
  },
}
</script>
